const nav = document.querySelector('[data-section-nav]');
const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
const listeners = new AbortController();

nav?.addEventListener('click', (event) => {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey ||
      event.ctrlKey || event.shiftKey || event.altKey) return;

  const link = event.target.closest('a[href^="#"]');
  if (!link || !nav.contains(link)) return;
  const target = document.getElementById(link.hash.slice(1));
  if (!target) return;

  event.preventDefault();
  // Keep shareable anchors and browser history without triggering the instant
  // hashchange corrections used to restore project/CV links on page entry.
  if (location.hash !== link.hash) history.pushState(null, '', link.hash);
  target.focus({ preventScroll: true });
  target.scrollIntoView({
    behavior: reducedMotion.matches ? 'instant' : 'smooth',
    block: 'start',
  });
}, { signal: listeners.signal });

if (import.meta.hot) import.meta.hot.dispose(() => listeners.abort());
